
import {
  apiVideo2Lists,
  apiVideo2Delete,
  apiChangeRemark,
  apiVideo2Cp, apiNewsShopLists
} from "@/api/shop";
import { Component, Prop, Vue } from "vue-property-decorator";
import lsPagination from "@/components/ls-pagination.vue";
import ExportData from "@/components/export-data/index.vue";
import LsDialog from "@/components/ls-dialog.vue";
import { RequestPaging } from "@/utils/util";
import DatePicker from "@/components/date-picker.vue";
import { apiOtherLists } from "@/api/order";
@Component({
  components: {
    lsPagination,
    ExportData,
    LsDialog,
    DatePicker,
  },
})
export default class ShopList extends Vue {
  /** S Data **/

  apiVideo2Lists = apiVideo2Lists;
  shopData: any[] = []

  pager: RequestPaging = new RequestPaging();

  searchObj = {
    set_meal_id: "",
    set_meal_status: "",
    status: "",
    shop_info: "",
    start_time: "",
    end_time: "",
    time_type: "",
  };
  otherLists: any = {
    set_meal: [],
    pay_status: [],
    pay_way: [],
  };
  /** E Data **/

  async getShopListsFn(): Promise<void> {
    const res: any = await apiNewsShopLists({
      page_no: 1,
      page_size: 100,
    })
    this.shopData = res.data;
  }

  /** S Methods **/
  // 获取订单其他 方式数据
  getOtherMethodList() {
    apiOtherLists().then((res: any) => {
      this.otherLists = res;
    });
  }
  // 获取视频列表
  getShopLists(): void {
    this.pager.request({
      callback: apiVideo2Lists,
      params: {
        ...this.searchObj,
      },
    });
  }

  async changeRemarks(text: string, id: number): Promise<void> {
    await apiChangeRemark({ id: id, remark: text });
    this.getShopLists();
  }

  // 删除视频
  async onShopDelete(row: any): Promise<void> {
    await apiVideo2Delete({ id: row.id });
    this.getShopLists();
  }

  // 重置搜索
  reset(): void {
    Object.keys(this.searchObj).map((key) => {
      this.$set(this.searchObj, key, "");
    });
    this.getShopLists();
  }

  //复制商家信息
  async toShopCp(id: number | any):Promise<void> {
    await apiVideo2Cp({ id: id });
    this.getShopLists();
  }


  // 去编辑视频
  toShopEdit(id: number | any): void {
    this.$router.push({
      path: "/shop/video1/edit",
      query: {
        id: id,
      },
    });
  }

  // 修改超级管理员
  toSuperAdminUpdate(id: number | any): void {
    this.$router.push({
      path: "/shop/modify_account",
      query: {
        id: id,
      },
    });
  }

  // 去商家后台
  toShop(url: any, status: number) {
    if (status == 0) return this.$message.error("该视频暂未营业中");

    if (url.indexOf("https://") === 0) window.open(url);
    else if (url.indexOf("http://") === 0) window.open(url);
    else window.open("http://" + url);
  }

  /** E Methods **/

  /** S ods **/
  created() {
    this.getShopLists();
    this.getOtherMethodList();
    this.getShopListsFn()
  }
}
